import React from 'react'
import { createRoot } from 'react-dom/client'
import PuzzleCreator from '../containers/PuzzlePlayer';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementsByClassName('puzzlePlayerApp')[0]
  if (container) {
    const root = createRoot(container)
    root.render(<PuzzleCreator />)
  }
})
